<template>
<div class="pre-analysis-wrapper">
  <div class="site-name">
    <h2>{{site.name}}</h2>
  </div>

  <el-tabs v-model="stepData[stepDataKey].tabName">
    <el-tab-pane
      v-for="component in components"
      :key="component.name"
      :name="component.name"
      :label="component.label"
    />
  </el-tabs>

  <Component
    :is="stepData[stepDataKey].tabName"
    :task-id="stepData.task.id"
    :data.sync="stepData[stepDataKey][componentMap[stepData[stepDataKey].tabName].dataKey]"
    :share-data="stepData[stepDataKey].shareData"
    :data-t-ss="stepData[stepDataKey].dataTSs"
    :condition="condition"
    :data-time-formatter="dataType.formatter"
    :site="site"
    @change="onChange"
  />
</div>
</template>

<script>
import loader from '../../../../../../utils/loader'
import BaseStep from '../BaseStep'

const components = Object.values(loader.getByFileName(require.context('./../preAnalysisComponents', true, /\.(vue)$/)))

const stepDataKey = 'preAnalysisData'

export default {
  name: 'PreAnalysisStep',
  label: '预分析',
  stepDataKey,
  extends: BaseStep,
  components: components.reduce((map, component) => {
    map[component.name] = component
    return map
  }, {}),
  computed: {
    stepDataKey: () => stepDataKey,
    components: () => components,
    componentMap: () => components.reduce((map, component) => {
      map[component.name] = component
      return map
    }, {})
  },
  methods: {
    onChange (flag) {
      this.changed = flag
    },
    nextStep () {
      return Promise.resolve(this.changed ? this.stepData[stepDataKey] : null)
    }
  },
  created () {
    let {stepData} = this

    if (!stepData[stepDataKey]) {
      stepData[stepDataKey] = components.reduce((map, component) => {
        map[component.dataKey] = null
        return map
      }, {
        shareData: null,
        dataTSs: Object.freeze([]),
        tabName: components[0].name
      })

      this.changeLoadStatus(true)
      this.$api.PMFAnalysis.concTimeSeries({
        id: this.stepData.task.id
      }).then(chartData => {
        const thisData = stepData[stepDataKey]
        const dataTSSet = new Set()

        thisData.shareData = Object.freeze(chartData.reduce((map, data) => {
          const {factorId} = data
          const dataTime = new Date(data.dataTime)
          let factorData = map[factorId]

          if (!factorData) {
            factorData = map[factorId] = {}
          }

          const ts = dataTime.getTime()
          const {conc, unc} = data

          factorData[ts] = {
            factorId,
            dataTime,
            conc: conc === -99999 ? null : Number(conc.toFixed(1)),
            unc: unc === -99999 ? null : Number(unc.toFixed(1))
          }

          dataTSSet.add(ts)

          return map
        }, {}))

        thisData.dataTSs = Object.freeze([...dataTSSet].sort((a, b) => a - b))
      }).catch(console.error).finally(() => {
        stepData = null
        this.changeLoadStatus(false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.pre-analysis-wrapper {
  display: grid;
  grid-template-rows: max-content max-content auto;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  > .site-name {
    > * {
      margin: 0;
      text-align: center;
    }
  }

  > .el-tabs {
    /deep/ {
      .el-tabs__header {
        margin-bottom: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/11PMF-Analysis/01PM/01Run/steps/02PreAnalysisStep.vue